import React from 'react';
import PropTypes from 'prop-types';
import {BeatLoader} from "react-spinners";
import {primaryColor} from "../../../../../../../../assets/jss/main";

Loader.propTypes = {
    loading: PropTypes.bool
};

function Loader({loading = false}) {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '400px',
            width: '100%'
        }}>
            <BeatLoader
                sizeUnit={"px"}
                size={12}
                color={primaryColor}
                loading={loading}
            />
        </div>
    );
}

export default Loader;
